const Type = {
  YES: 'Sim',
  NO: 'Não',
  OK: 'Ok',
  CANCEL: 'Cancelar'
};

export default Type;
